export const CONNECT_WIDGET_ID = 'connect_widget'
export const CONNECTIONS_WIDGET_ID = 'connections_widget'

// Connection state shared by the foundational `common` layer (ConnectDrawer /
// ConnectStatus) and the accounts widget. Lives in `common` so `common` does not
// have to depend on `accounts` (which created a common->accounts layering
// violation and blocked per-widget code splitting).
export enum MemberConnectionStatus {
  Loading = 'loading',
  Error = 'error',
}
